import { render, staticRenderFns } from "./EModalJustificarFalta.vue?vue&type=template&id=31104e3a&scoped=true"
import script from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
export * from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
import style0 from "./EModalJustificarFalta.vue?vue&type=style&index=0&id=31104e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31104e3a",
  null
  
)

export default component.exports